import { API_CONFIG, API_ENDPOINTS } from '../config/api.config';

class AuthService {
  constructor() {
    this.baseURL = API_CONFIG.BASE_URL;
    this.tokenKey = 'rullier_auth_token';
    this.refreshTokenKey = 'rullier_refresh_token';
    this.userKey = 'rullier_user_data';
  }

  // Récupérer le token d'accès
  getAccessToken() {
    return localStorage.getItem(this.tokenKey);
  }

  // Récupérer le refresh token
  getRefreshToken() {
    return localStorage.getItem(this.refreshTokenKey);
  }

  // Récupérer les données utilisateur
  getUserData() {
    const userData = localStorage.getItem(this.userKey);
    return userData ? JSON.parse(userData) : null;
  }

  // Sauvegarder les tokens et données utilisateur
  saveAuthData(authData) {
    console.log('=== SAUVEGARDE DES DONNÉES ===');
    console.log('Auth data reçu:', authData);
    
    // Extraire les tokens depuis jwt_tokens
    let accessToken = null;
    let refreshToken = null;
    let userData = null;
    
    // Vérifier si jwt_tokens existe
    if (authData.jwt_tokens) {
      accessToken = authData.jwt_tokens.access;
      refreshToken = authData.jwt_tokens.refresh;
    } else {
      // Fallback pour d'autres formats
      accessToken = authData.access_token || authData.access || authData.token || authData.jwt || authData.accessToken;
      refreshToken = authData.refresh_token || authData.refresh || authData.refreshToken;
    }
    
    // Extraire les données utilisateur
    userData = authData.user || authData.user_data;
    
    console.log('Access token trouvé:', accessToken ? 'OUI' : 'NON');
    console.log('Refresh token trouvé:', refreshToken ? 'OUI' : 'NON');
    console.log('User data trouvé:', userData ? 'OUI' : 'NON');
    
    if (accessToken) {
      localStorage.setItem(this.tokenKey, accessToken);
      console.log('Access token sauvegardé');
    } else {
      console.log('AUCUN ACCESS TOKEN TROUVÉ');
      console.log('Toutes les clés disponibles:', Object.keys(authData));
    }
    
    if (refreshToken) {
      localStorage.setItem(this.refreshTokenKey, refreshToken);
      console.log('Refresh token sauvegardé');
    }
    
    if (userData) {
      localStorage.setItem(this.userKey, JSON.stringify(userData));
      console.log('User data sauvegardé');
    }
    
    console.log('=== FIN SAUVEGARDE ===');
  }

  // Supprimer les données d'authentification
  clearAuthData() {
    localStorage.removeItem(this.tokenKey);
    localStorage.removeItem(this.refreshTokenKey);
    localStorage.removeItem(this.userKey);
  }

  // Vérifier si l'utilisateur est connecté
  isAuthenticated() {
    const token = this.getAccessToken();
    
    if (!token) return false;

    try {
      // Vérifier si le token n'est pas expiré
      const payload = JSON.parse(atob(token.split('.')[1]));
      const currentTime = Date.now() / 1000;
      const isValid = payload.exp > currentTime;
      return isValid;
    } catch (error) {
      console.error('Erreur lors de la vérification du token:', error);
      return false;
    }
  }

  // Connexion
  async login(credentials) {
    try {
      console.log('Attempting login with credentials:', credentials);
      const response = await fetch(`${this.baseURL}${API_ENDPOINTS.AUTH.LOGIN}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(credentials),
      });

      console.log('Login response status:', response.status);

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.detail || `Erreur de connexion: ${response.status}`);
      }

      const authData = await response.json();
      console.log('=== RÉPONSE API COMPLÈTE ===');
      console.log('Auth data:', authData);
      console.log('Auth data type:', typeof authData);
      console.log('Auth data keys:', Object.keys(authData));
      console.log('Auth data stringified:', JSON.stringify(authData, null, 2));
      
      this.saveAuthData(authData);
      
      return {
        success: true,
        data: authData,
      };
    } catch (error) {
      console.error('Erreur de connexion:', error);
      return {
        success: false,
        error: error.message,
      };
    }
  }

  // Rafraîchir le token
  async refreshToken() {
    const refreshToken = this.getRefreshToken();
    if (!refreshToken) {
      throw new Error('Aucun refresh token disponible');
    }

    try {
      const response = await fetch(`${this.baseURL}${API_ENDPOINTS.AUTH.REFRESH}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${refreshToken}`,
        },
      });

      if (!response.ok) {
        throw new Error('Échec du rafraîchissement du token');
      }

      const authData = await response.json();
      this.saveAuthData(authData);
      
      return authData;
    } catch (error) {
      console.error('Erreur lors du rafraîchissement du token:', error);
      this.clearAuthData();
      throw error;
    }
  }

  // Déconnexion
  async logout() {
    try {
      const token = this.getAccessToken();
      if (token) {
        await fetch(`${this.baseURL}${API_ENDPOINTS.AUTH.LOGOUT}`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
          },
        });
      }
    } catch (error) {
      console.error('Erreur lors de la déconnexion:', error);
    } finally {
      this.clearAuthData();
    }
  }

  // Obtenir les headers d'authentification
  getAuthHeaders() {
    const token = this.getAccessToken();
    return token ? { 'Authorization': `Bearer ${token}` } : {};
  }
}

// Instance singleton
export const authService = new AuthService();
export default authService; 